// Shared control classes for the manual-booking form and its parts. One
// definition so a field extracted into its own file cannot drift visually.
export const inputCls =
  'w-full rounded-[var(--radius-control)] border border-border bg-input px-3 py-2 text-sm text-foreground placeholder:text-muted focus:outline-none focus:border-accent focus:ring-[3px] focus:ring-[var(--focus-glow)]';

export const labelCls = 'mb-1 block text-xs font-medium uppercase tracking-wider text-muted';
